import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const VideoWindow = ({ stream }) => {
  const videoRef = useRef(null)

  useEffect(() => {
    if (videoRef.current && stream) {
      console.log('비디오 스트림 설정:', stream)
      videoRef.current.srcObject = stream
      videoRef.current.play().catch((error) => {
        console.error('비디오 재생 실패:', error)
      })
    }
  }, [stream])

  return (
    <div className="vc-video-container">
      <video ref={videoRef} className="vc-video-window" autoPlay playsInline muted={false} />
      {!stream && <div className="vc-video-placeholder">상대방의 비디오가 표시됩니다</div>}
    </div>
  )
}

VideoWindow.propTypes = {
  stream: PropTypes.any,
}

export default VideoWindow
